import script from "./VCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./VCheck.vue?vue&type=script&lang=ts&setup=true"

import "./VCheck.vue?vue&type=style&index=0&id=764c1424&lang=sass"

const __exports__ = script;

export default __exports__